console.log("NEREO JS CARGADO");

document.addEventListener("DOMContentLoaded", () => {

  const section = document.querySelector(".nereo-counters");

  if (!section) return;


  const counters = section.querySelectorAll("[data-counter]");


  function animateCounter(counter) {

    const target = Number(counter.dataset.counter);

    let current = 0;

    const duration = 2000;
    const increment = target / (duration / 16);


    function update() {

      current += increment;


      if (current < target) {

        counter.textContent = Math.floor(current);

        requestAnimationFrame(update);

      } else {

        counter.textContent = target;

      }

    }


    update();

  }



  const observer = new IntersectionObserver((entries) => {


    entries.forEach(entry => {


      if (entry.isIntersecting) {


        counters.forEach(counter => {

          animateCounter(counter);

        });


        observer.unobserve(section);

      }


    });


  }, {

    threshold: 0.5

  });



  observer.observe(section);


});